require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-are-the-world-banks-investments-in-argentina-aligned.json") })
        }
      }, "path---en-us-update-are-the-world-banks-investments-in-argentina-aligned");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-are-the-world-banks-investments-in-argentina-aligned!./.cache/json/en-us-update-are-the-world-banks-investments-in-argentina-aligned.json
// module id = 613
// module chunks = 231608221292675